import moment from "moment";
import { useEffect, useState } from "react";
import { dbDateFormat } from "../constants/constants";

type DateFilterType = {
  startDate?: string;
  endDate?: string;
};

type SelectType = "today" | "week" | "month" | "";

export default function useSelect(defaultSelect = "" as SelectType) {
  const [select, setSelect] = useState<SelectType>(defaultSelect);
  const [dateFilter, setDateFilter] = useState<DateFilterType>({
    startDate: undefined,
    endDate: undefined,
  });

  useEffect(() => {
    switch (select) {
      case "today":
        setDateFilter({
          startDate: moment().format(dbDateFormat),
          endDate: moment().format(dbDateFormat),
        });
        break;
      case "week":
        const startOfWeek = moment().day(6);
        const endOfWeek = moment().day(5 + 7);

        if (moment().day() >= 6) {
          startOfWeek.subtract(0, "weeks");
          endOfWeek.subtract(0, "weeks");
        } else {
          startOfWeek.subtract(1, "weeks");
          endOfWeek.subtract(1, "weeks");
        }

        setDateFilter({
          startDate: startOfWeek.format(dbDateFormat),
          endDate: endOfWeek.format(dbDateFormat),
        });
        break;
      case "month":
        setDateFilter({
          startDate: moment().startOf("month").format(dbDateFormat),
          endDate: moment().endOf("month").format(dbDateFormat),
        });
        break;
    }
  }, [select]);

  const handleDateChange = (dates?: any) => {
    if (dates?.length) {
      const startDate = dates[0]?.format(dbDateFormat) || undefined;
      const endDate = dates[1]?.format(dbDateFormat) || undefined;

      if (startDate && endDate) {
        setSelect("");
      }

      setDateFilter({
        startDate,
        endDate,
      });
    }
  };

  return {
    handleDateChange,
    setSelect: (val: SelectType) => setSelect(val),
    select,
    dateFilter: {
      startDate: dateFilter?.startDate
        ? `${dateFilter?.startDate} 00:00:00`
        : undefined,
      endDate: dateFilter?.endDate
        ? `${dateFilter?.endDate} 23:59:59`
        : undefined,
    },
  };
}
